import React, { useState } from 'react';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { Box, Button, Grid, MenuItem, Stack, TextField } from '@mui/material';

import { useGetOrganizationsQuery } from '@/services';
import { AppBar, Empty, Error, Loader } from '@/components';
import { OrderDirections, ORDER_DIRECTIONS } from '@/utils/order-directions';

import { OrganizationsTable, CreateOrganization } from './components';

const OrganizationsPage: React.FC = () => {
  const [{ order_direction, page }, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    order_direction: withDefault(StringParam, OrderDirections.DESC),
  });

  const [createModalOpened, setOpenedCreateModal] = useState(false);

  const {
    data: organizations,
    isLoading,
    isSuccess,
    isError,
  } = useGetOrganizationsQuery({ params: { order_direction, page, order_by: 'id' } });

  return (
    <>
      <AppBar title="Дочерние организации" />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
            <Box sx={{ width: 310 }}>
              <TextField
                select
                value={order_direction}
                label="Сортировать по"
                disabled={isLoading}
                onChange={(event) => setQuery({ order_direction: event.target.value }, 'replace')}
                variant="filled"
                fullWidth
                size="small"
              >
                {ORDER_DIRECTIONS.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box sx={{ width: 210 }}>
              <Button
                disabled={isLoading}
                onClick={() => setOpenedCreateModal(true)}
                size="large"
                variant="contained"
                fullWidth
              >
                Добавить
              </Button>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          {isLoading ? (
            <Loader />
          ) : isError ? (
            <Error text="Произошла ошибка с загрузкой дочерних организаций! Пожалуйста, попробуйте позже" />
          ) : isSuccess && Boolean(organizations?.data?.length) ? (
            <OrganizationsTable list={organizations} page={page} onChangePage={(page) => setQuery({ page })} />
          ) : (
            <Empty text="Дочерние организации отсутствуют" />
          )}
        </Grid>
      </Grid>

      <CreateOrganization onClose={() => setOpenedCreateModal(false)} open={createModalOpened} />
    </>
  );
};

export default OrganizationsPage;
